import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import createContext from 'zustand/context';
var store = createContext();
export var useStore = store.useStore;
export var useStoreApi = store.useStoreApi;
export var useComponent = function useComponent(id) {
  var selector = useCallback(function (content) {
    return content[id];
  }, [id]);
  return useStore(selector);
};
var Provider = store.Provider;
export var StoreProvider = function StoreProvider(_ref) {
  var children = _ref.children,
      createStore = _ref.createStore;
  return _jsx(Provider, Object.assign({
    createStore: createStore
  }, {
    children: children
  }));
};
StoreProvider.displayName = 'StoreProvider';
export var withStoreProvider = function withStoreProvider(createStore) {
  return function (Component) {
    var StoreProviderContainer = function StoreProviderContainer(props) {
      return _jsx(StoreProvider, Object.assign({
        createStore: createStore
      }, {
        children: _jsx(Component, Object.assign({}, props))
      }));
    };

    StoreProviderContainer.displayName = 'StoreProviderContainer';
    return StoreProviderContainer;
  };
};